import React, { Component } from "react";
import Header from "./Header/header";
import Footer from "./Footer/footer";
import SideMenu from "./SideMenu/sideMenu";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { SideMenuToggle } from "../../Redux/Action/SideMenuAction";
import { Redirect, Route, Switch } from "react-router-dom";
import "./defaultLayout.css";
import routes from "../../routes";
import cookie from "react-cookies";
import {
  MyTicket_USER,
  MyTicket_TOKEN,
  MyTicket_LANGUAGE,
  MyTicket_USER_Cinema,
  MyTicket_TOKEN_Cinema,
  MyTicket_LANGUAGE_Cinema,
  MyTicket_USER_Event,
  MyTicket_TOKEN_Event,
  MyTicket_LANGUAGE_Event,
} from "../../AppConfig";
import { IntializeToken } from "../../Redux/Action/LoginAction";
import { init } from "../../Redux/Action/SocketAction";
import LoadingBar from "react-redux-loading-bar";

class DefaultLyout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: false, // true=>ar
      open: true,
      smallScreen: false,
      LayoutColorBG: "",
    };
  }
  handelOpenClose = (flag) => {
    this.props.SideMenuToggle(flag);
    this.setState({ open: flag });
  };

  // componentDidMount() {
  //     this.setState({ LayoutColorBG: localStorage.getItem('LayoutColor') })
  // }

  componentWillMount() {
    this.setState({ LayoutColorBG: localStorage.getItem("LayoutColor") });
    if (window.innerWidth < 766) {
      this.setState({ smallScreen: true, flag: false });
    }
    if (this.props.token) {
    } else {
      let UserType = sessionStorage.getItem("TicketUser");

      let token, user, tempLang, lang;
      if (UserType === "ADMIN" || UserType === "SUB_ADMIN") {
        token = sessionStorage.getItem(MyTicket_TOKEN)
        user = sessionStorage.getItem(MyTicket_USER)
        tempLang = sessionStorage.getItem(MyTicket_LANGUAGE)
        lang = JSON.parse(tempLang);

      }
      if (token && token !== "null" && token && token !== null) {
        this.props.IntializeToken(token, lang, user);
      }
    }
    this.props.init();
  }

  render() {
    let direction = this.props.lang === "ar" ? true : false;
    let UserType = sessionStorage.getItem("TicketUser");
    let token = sessionStorage.getItem(MyTicket_TOKEN)

    let layoutBCK = this.props.layoutColor;
    if (layoutBCK && layoutBCK !== this.state.LayoutColorBG) {
      this.setState({ LayoutColorBG: layoutBCK });
    }
   
    return token !== "null" && token !== null && token !== undefined ? (
      <div>
        <div className="loading-bar">
          <LoadingBar
            style={{
              height: "3px",
              zIndex: 1250,
              backgroundImage: `linear-gradient(to right, #FF5438, #FF8044)`,
            }}
          />
        </div>

        <div
          style={{
            paddingBottom: "1px",
            backgroundColor: this.state.LayoutColorBG
              ? this.state.LayoutColorBG
              : "#EBEDEF",
            minHeight: "95vh",
            direction: direction ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              width: this.state.smallScreen
                ? "100vw"
                : this.state.open
                ? "81vw"
                : "95vw",
              transition: "all 0.6s ease",
              margin:
                this.props.lang === "en" ? "0 10px 0 auto" : "0 auto 0 10px",
            }}
          >
            <div style={{ zIndex: "2000", position: "relative" }}>
              <SideMenu
                handeltoggle={this.handelOpenClose}
                direction={direction}
              />
            </div>
            <div>
              <Header IsOpen={this.state.open} direction={direction} />
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) => <route.component {...props} />}
                    />
                  ) : null;
                })}
                <Redirect from="/" to={"/MyTicket/Dashboard"} />
              </Switch>
            </div>
          </div>
        </div>

        <Footer IsOpen={this.state.open} direction={direction} />
      </div>
    ) : (
      <Redirect to={"/MyTicket/admin-login"} />
      // null
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.userInfo.token,
    lang: state.userInfo.language,
    layoutColor: state.setting.layoutColor,
    user: state.userInfo.user,
    type: state.userInfo.Type,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      init,
      SideMenuToggle,
      IntializeToken,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLyout);
